/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ withDob: NonNullable<unknown>, total: NonNullable<unknown> }} Signupsagecoverage2Inputs */

const en_signupsagecoverage2 = /** @type {(inputs: Signupsagecoverage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.withDob} of ${i?.total} accounts that set a birth date.`)
};

const de_signupsagecoverage2 = /** @type {(inputs: Signupsagecoverage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aus ${i?.withDob} von ${i?.total} Konten mit Geburtsdatum.`)
};

/**
* | output |
* | --- |
* | "From {withDob} of {total} accounts that set a birth date." |
*
* @param {Signupsagecoverage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsagecoverage2 = /** @type {((inputs: Signupsagecoverage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsagecoverage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsagecoverage2(inputs)
	return de_signupsagecoverage2(inputs)
});
export { signupsagecoverage2 as "signupsAgeCoverage" }